var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManufacturing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FDF3E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 19.25h-.52l-.182.486-1.852 4.94a1.25 1.25 0 01-1.514.762l-1.143-.326-1.164-.333a1.25 1.25 0 01-.886-1.432l1.859-9.91a1.25 1.25 0 011.23-1.02h9.172a3.417 3.417 0 110 6.833h-5z",
    stroke: "#EE9437",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 29.166l.833-3.333",
    stroke: "#EE9437",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.167 12.5v6.667",
    stroke: "#EE9437",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15.833H30M19.167 15h2.5",
    stroke: "#EE9437",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNGREYzRTciLz4KPHBhdGggZD0iTTE5LjE2NjggMTkuMjQ5OEgxOC42NDcxTDE4LjQ2NDYgMTkuNzM2NUwxNi42MTI1IDI0LjY3NTRDMTYuMzgzOCAyNS4yODU0IDE1LjcyNSAyNS42MTc0IDE1LjA5ODcgMjUuNDM4NEwxMy45NTYyIDI1LjExMkwxMi43OTE3IDI0Ljc3OTNDMTIuMTcxMSAyNC42MDIgMTEuNzg3NSAyMy45ODE0IDExLjkwNjUgMjMuMzQ3TDEzLjc2NDYgMTMuNDM2OUMxMy44NzU2IDEyLjg0NTIgMTQuMzkyMSAxMi40MTY1IDE0Ljk5NDEgMTIuNDE2NUgyNC4xNjY4QzI2LjA1MzggMTIuNDE2NSAyNy41ODM1IDEzLjk0NjIgMjcuNTgzNSAxNS44MzMyQzI3LjU4MzUgMTcuNzIwMSAyNi4wNTM4IDE5LjI0OTggMjQuMTY2OCAxOS4yNDk4SDE5LjE2NjhaIiBzdHJva2U9IiNFRTk0MzciIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xMi41IDI5LjE2NjNMMTMuMzMzMyAyNS44MzMiIHN0cm9rZT0iI0VFOTQzNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjQuMTY3IDEyLjVWMTkuMTY2NyIgc3Ryb2tlPSIjRUU5NDM3IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMjcuNSAxNS44MzNIMzAiIHN0cm9rZT0iI0VFOTQzNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkuMTY3IDE1SDIxLjY2NyIgc3Ryb2tlPSIjRUU5NDM3IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPg==";
export { SvgManufacturing as ReactComponent };